// removed by extract-text-webpack-plugin
module.exports = {"notFoundContainer":"_2b2Rol22rF5vALMxOEFDZS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/not-found/NotFound.css
// module id = 560
// module chunks = 0